import { axios } from "../axiosInstance";
import type {
  DataAdminCreate,
  DataAdminView,
  SyncFirmAssignment,
} from "../interfaces/models/IDataAdmin";

export const getDataAdmin = async (): Promise<DataAdminCreate[]> => {
  try {
    const dataAdmin = await axios.Get("./dataAdmin");
    return dataAdmin.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const updateDataAdmin = async (
  dataAdmin: DataAdminCreate,
): Promise<unknown> => {
  try {
    const res = await axios.Put("DataAdmin", dataAdmin);
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createDataAdmin = async (
  dataAdmin: DataAdminCreate,
): Promise<unknown> => {
  try {
    const res = await axios.Post("DataAdmin", dataAdmin);
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDataAdmin = async (id: string): Promise<boolean> => {
  try {
    const response = await axios.Delete(`DataAdmin`, `${id}`);
    return response.status === 200;
  } catch (error) {
    console.error("Error deleting data admin:", error);
    throw error;
  }
};

export const getDataAdminByFirm = async (
  firmId: string,
): Promise<DataAdminView[]> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ firm: { value: firmId, comparisonType: "EQUAL" } }),
    );
    const dataAdmin = await axios.Get(`./dataAdmin?${params.toString()}`);
    return dataAdmin.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const getDataAdminByFirmId = async (
  firmId: string,
): Promise<DataAdminView[]> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ firmId: { value: firmId, comparisonType: "EQUAL" } }),
    );
    const response = await axios.Get(`./dataAdmin?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching data admins by firm:", error);
    throw error;
  }
};

export const syncDataAdminsForFirm = async (
  firmId: string,
  assignments: SyncFirmAssignment[],
): Promise<DataAdminView[]> => {
  try {
    const response = await axios.PutDataIntoModel(
      `./dataAdmin?action=syncFirm`,
      { firmId, assignments },
    );
    return response.data;
  } catch (error) {
    console.error("Error syncing data admins:", error);
    throw error;
  }
};

export const getDataAdminLastLoginByFirm = async (
  firmId: string,
): Promise<DataAdminView[]> => {
  try {
    const dataAdmin = await axios.Get(
      `./dataAdmin?lastLogin=true&firmId=${firmId}`,
    );
    return dataAdmin.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
